export default "﻿<div class=\"\">\n    \n</div>\n"